import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';
import { SidebarLayout } from 'src/layouts/SidebarLayout';
import { BaseLayout } from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import Users from './content/dashboards/Users';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages

const Login = Loader(lazy(() => import('src/content/login')));

// Dashboards

const Dashboard = Loader(
  lazy(() => import('src/content/dashboards/Dashboard'))
);

const Countries = Loader(
  lazy(() => import('src/content/dashboards/Countries'))
);

const Logs = Loader(
  lazy(() => import('src/content/dashboards/EsimoneyAdminLogs'))
);

const Coupons = Loader(lazy(() => import('src/content/dashboards/Coupons')));

const SuspiciousUsers = Loader(lazy(() => import('src/content/dashboards/SuspiciousUsers')));

const Businesses = Loader(lazy(() => import('src/content/dashboards/Businesses')));

const BusinessDetail = Loader(
  lazy(() => import('src/content/dashboards/Businesses/BusinessDetailPage'))
);

const Packages = Loader(lazy(() => import('src/content/dashboards/Packages')));

const Purchases = Loader(
  lazy(() => import('src/content/dashboards/Purchases'))
);

// Applications

const UserProfile = Loader(
  lazy(() => import('src/content/applications/Users/profile'))
);

const Settings = Loader(
  lazy(() => import('src/content/applications/Settings'))
);

// Status

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Login />
      },
      {
        path: 'login',
        element: <Navigate to="/" replace />
      },
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: 'dashboards',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="countries" replace />
      },
      {
        path: 'dashboard',
        element: <Dashboard />
      },
      {
        path: 'purchases',
        element: <Purchases />
      },
      {
        path: 'packages',
        element: <Packages />
      },
      {
        path: 'countries',
        element: <Countries />
      },
      {
        path: 'logs',
        element: <Logs />
      },
      {
        path: 'coupons',
        element: <Coupons />
      },
      {
        path: 'users',
        element: <Users />
      },
      {
        path: 'suspicious-users',
        element: <SuspiciousUsers />
      },
      {
        path: 'businesses',
        element: <Businesses />
      },
      {
        path: 'businesses/:businessId',
        element: <BusinessDetail />
      }
    ]
  },
  {
    path: 'settings',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="settings" replace />
      },
      {
        path: 'settings',
        element: <Settings />
      }
    ]
  },
  {
    path: '/components',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="buttons" replace />
      }
    ]
  },
  {
    path: 'management',
    element: <SidebarLayout />,
    children: [
      {
        path: 'profile',
        children: [
          {
            path: '',
            element: <Navigate to="details" replace />
          },
          {
            path: 'details/:userId',
            element: <UserProfile />
          }
        ]
      }
    ]
  }
];

export default routes;
